import { SharedModule } from './../../shared/shared.module';
import { CapacityOverrideRoutingModule } from './capacity-override-routing.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CapacityOverrideComponent } from './capacity-override.component';



@NgModule({
  declarations: [
    CapacityOverrideComponent
  ],
  imports: [
    CommonModule,
    CapacityOverrideRoutingModule,
    SharedModule
  ]
})
export class CapacityOverrideModule { }
